module.exports = __webpack_public_path__ + "img/card_error_bg.d71a7132.svg";